import http from '@/utils/http'
// 下单
export const createOrder = (data) => {
  return http({
    method: 'post',
    url: '/bs/phoenix/quoteOrder/createOrder',
    data,
  })
}
// 人工报价-下单
export const createOrderV2 = (data) => {
  return http({
    method: 'post',
    url: '/bs/phoenix/quoteOrder/createOrderV2',
    data,
  })
}
// 查询订单列表
export const queryOrderList = (data) => {
  return http({
    method: 'post',
    url: '/bs/phoenix/quoteOrder/queryOrderList',
    data: {
      list_type: 0,
      ...data,
    },
  })
}
// 查询订单详情
export const queryThirdOrder = (data) => {
  return http({
    method: 'post',
    url: '/bs/phoenix/quoteOrder/queryThirdOrder',
    data,
  })
}